// PropertyBoundaryLayer.tsx
import { useState, useEffect } from "react";
import ToolbarButton from "../toolbar/ToolbarButton";
import { useProject } from "../../api/project";
import { DEFAULT_PROJECT_PAGE_PROPERTY_STYLE, resolveBoundaryStyle } from "../../types/boundaryStyle";

const PropertyBoundaryLayer = (
  id: string,
  name: string,
  onTop: boolean = false,
) => {
  const { project } = useProject();
  const [geojson, setGeojson] = useState<any>(null);
  const [active, setActive] = useState(true);
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (project?.data?.properties) {
      // Convert array of features to a FeatureCollection
      const featureCollection = {
        type: "FeatureCollection",
        features: project.data.properties
      };
      setGeojson(featureCollection);
      setStale(true);
    }
  }, [project?.data?.properties]);

  // The outline, in the project's own style when one has been set (from the
  // listing's "Property boundary style…"), else the green it has always been.
  const style = resolveBoundaryStyle(project?.data?.property_style, DEFAULT_PROJECT_PAGE_PROPERTY_STYLE);
  const outlineLayerStyle = {
    id: id,
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round",
    },
    paint: {
      "line-color": style.color,
      "line-width": style.width,
      "line-opacity": style.opacity,
    },
  };

  const toolbarButton = (
    <ToolbarButton
      key={id}
      id={id}
      name={name}
      toggledOn={active}
      enabled={!!geojson}
      onClick={() => setActive(!active)}
      icon={"location_on"}  // Using location icon for properties
    />
  );

  return {
    id: id,
    name: name,
    source: geojson,
    rawSource: geojson,
    layerStyle: outlineLayerStyle,  // Return both fill and outline layers
    toolbarButton: toolbarButton,
    active: active,
    stale: stale,
    setStale: setStale,
    onTop: onTop,
  };
};

export default PropertyBoundaryLayer;
